export const bulkSaveOutputs = ({original_save_id, designs, folderId}) => {
    const url = global.config.server_path+'saved_design/bulk_save';
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', 'body': JSON.stringify({original_save_id, folderId, designs})})
};

export const uploadImage = ({image, folderId}) => {
    const data = new FormData();
    data.append('file', image, image.name);
    data.append('folder_id', folderId);
    const url = global.config.server_path + 'folder/upload_file';
    return fetch(url, {method: 'POST', 'credentials': 'include', body: data})
};